(() => {
  if (window.ninjaDeliveryEstimate) {
    window.ninjaDeliveryEstimate(document);
    return;
  }
  const advance = (date, days, business) => {
    const result = new Date(date);
    let added = 0;
    while (added < days) {
      result.setUTCDate(result.getUTCDate() + 1);
      const weekday = result.getUTCDay();
      if (!business || (weekday !== 0 && weekday !== 6)) added += 1;
    }
    return result;
  };
  const update = (root) => {
    const estimates = root.matches?.('[data-delivery-estimate]')
      ? [root]
      : root.querySelectorAll('[data-delivery-estimate]');
    estimates.forEach((element) => {
      element.hidden = true;
      const config = element.dataset;
      const countries = (config.countries || '').split(',').map((country) => country.trim().toUpperCase());
      if (!/^[A-Z]{2}$/.test(config.origin || '') || (!countries.includes('*') && !countries.includes(config.country))) return;
      const min = Number(config.minDays);
      const max = Number(config.maxDays);
      const cutoff = Number(config.cutoffHour);
      if (!Number.isInteger(min) || !Number.isInteger(max) || min < 0 || max < min || max > 60) return;
      if (!Number.isInteger(cutoff) || cutoff < 0 || cutoff > 23) return;
      if (!['business', 'calendar'].includes(config.dayType) || !config.timezone) return;
      try {
        const parts = new Intl.DateTimeFormat('en-GB', {
          timeZone: config.timezone === 'local' ? Intl.DateTimeFormat().resolvedOptions().timeZone : config.timezone,
          year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23'
        }).formatToParts(new Date());
        const dateParts = Object.fromEntries(parts.map((part) => [part.type, part.value]));
        let start = new Date(Date.UTC(Number(dateParts.year), Number(dateParts.month) - 1, Number(dateParts.day), 12));
        const business = config.dayType === 'business';
        if (config.dayType === 'business' && Number(dateParts.hour) >= cutoff) start = advance(start, 1, false);
        if (business) {
          while ([0, 6].includes(start.getUTCDay())) start = advance(start, 1, false);
        }
        const earliest = advance(start, min, business);
        const latest = advance(start, max, business);
        const formatter = new Intl.DateTimeFormat('de-DE', {
          timeZone: 'UTC', weekday: 'short', day: '2-digit', month: '2-digit', year: 'numeric'
        });
        const output = element.querySelector('[data-delivery-dates]');
        if (!output) return;
        output.textContent = min === max
          ? formatter.format(earliest)
          : `${formatter.format(earliest)} – ${formatter.format(latest)}`;
        element.hidden = false;
      } catch {
        element.hidden = true;
      }
    });
  };
  window.ninjaDeliveryEstimate = update;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => update(document), { once: true });
  else update(document);
  document.addEventListener('shopify:section:load', (event) => update(event.target));
  window.addEventListener('pageshow', () => update(document));
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) update(document);
  });
  setInterval(() => update(document), 60000);
})();
